import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
@Component({
  selector: 'web-di-ld-face-scan-process',
  templateUrl: './face-scan-process.component.html',
  styleUrls: ['./face-scan-process.component.scss'],
})
export class FaceScanProcessComponent {
  @Input() path = '';
  @Input() title = '';
  @Input() description = '';
  @Input() width = '';
  @Input() isShowLaterBtn = false;
  @Input() isPendingAnimate = false;
  @Input() btnText = 'รอผลภายหลัง';
  @Input() waitingDesc = '';
  @Input() isMarginTop = false;

  animateOptions: AnimationOptions = {
    path: '/assets/animation/pending-icon/pending-icon.json',
  };
  @Output() onClick = new EventEmitter();

  constructor() {}

  onLater() {
    this.onClick.emit();
  }
}
